import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedUploadURLForSpocsRPC } from "./getPresignedUploadUrlForSpocsRPC";

export class GetPresignedUploadURLForSpocsRPCClientImpl extends GetPresignedUploadURLForSpocsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedUploadURLForSpocsRPC.Request): Promise<LeoRPCResult<GetPresignedUploadURLForSpocsRPC.Response, GetPresignedUploadURLForSpocsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/GetPresignedUploadURLForSpocs",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedUploadURLForSpocsRPC.ResponseDTO,
      GetPresignedUploadURLForSpocsRPC.Errors.ErrorsDTO,
      GetPresignedUploadURLForSpocsRPC.Response,
      GetPresignedUploadURLForSpocsRPC.Errors.Errors
    >(
      response,
      "spoc-management/GetPresignedUploadURLForSpocs",
      GetPresignedUploadURLForSpocsRPC.Response.fromDTO,
      GetPresignedUploadURLForSpocsRPC.Errors.fromDTO
    );
  }
}
